import styles from '../styles/details/id.module.scss';
import React from 'react'
import { getCourseItem, getCourseUrl } from '../../constants/api'
import { http } from '../../utils/api'
import Layout from '../../components/MyLayout'
import { NextPage, NextPageContext } from 'next';
import { Button, Card, Col, Descriptions, List, Modal, PageHeader, Row, Typography } from 'antd';
import { PreviewOpen, Time } from '@icon-park/react';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
import Link from 'next/link';
import Meta from 'antd/lib/card/Meta';
import { Item } from '../../@types/curriculum';
import { title } from '../../constants/heads';
const { Title, Text, Paragraph } = Typography;

const typeList = [
    {
        name: '图文',
        type: 1
    },
    {
        name: '视频',
        type: 2
    }
],
    levelList = [
        {
            name: '入门',
            type: 1
        },
        {
            name: '初级',
            type: 2
        },
        {
            name: '中级',
            type: 3
        },
        {
            name: '高级',
            type: 4
        }
    ],
    costList = [
        {
            name: '免费',
            type: 1
        },
        {
            name: '收费',
            type: 2
        }
    ]

type Props = {
    data: {
        data: Item,
        url: string
        list: Item[]
    }
}

const FontId: NextPage<Props> = (props) => {
    const { data, list } = props.data
    const { userInfo, baseUrl, cdnUrl, responsive } = useSelector((state: State) => state)
    const { isXs, isSm, isMd, isXxl } = responsive

    const head = {
        title: `${data.title}-${title}`,
        description: data.vice,
        keywords: data.title
    }

    const levelFil = (val: number) => {
        let name = "";
        levelList.map((v, k) => {
            if (val == v.type) name = v.name;
        });
        return name;
    }

    const footer = (
        <Row gutter={[16, 20]}>
            {
                data.html ?
                    <Col span={24} className="markdown-body works-cont">
                        <div dangerouslySetInnerHTML={{ __html: data.html }}></div>
                    </Col> :
                    <Col span={24} className="works-cont ql-container ql-snow">
                        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: data.content }}></div>
                    </Col>
            }
        </Row>
    )
    const drawCourse = async () => {
        const { decrypted } = (await import('../../utils/rsa'))
        const res: any = await http(getCourseUrl, { id: data._id })
        if (res.code == 200) {
            let url = decrypted(res.data.download)
            let pas = decrypted(res.data.password)
            Modal.info({
                title: '下载地址',
                icon: null,
                content: (
                    <div style={{ textAlign: 'center' }}>
                        <Title level={3}><Paragraph copyable={{ text: pas }}>密码:{pas}</Paragraph></Title>
                        <div>
                            <Button type="primary"><a target="_blank" href={url}>前往下载页面</a></Button>
                        </div>
                        <div style={{ paddingTop: '15px' }}>
                            <Text type="secondary">低版本浏览器需手动复制密码再前往下载页面</Text>
                        </div>
                    </div>
                ),
                onOk() { },
            });
        }

    }


    return (
        <Layout head={head} styles={['/css/github.css', '/css/github-markdown.css']} className={styles.details}>
            <div className="content" style={{ paddingTop: '10px' }}>
                <PageHeader
                    title={data.title}
                    extra={[
                        !data.charge && data.style == 2 ?
                            <Button key="Download" onClick={drawCourse} type="primary">
                                &nbsp;立即领取
                            </Button> : null
                    ]}
                    footer={footer}
                >
                    <div className="main">{
                        <Descriptions size="small" column={isXs ? 2 : 5}>
                            <Descriptions.Item label="分类">{data.category_name}</Descriptions.Item>
                            <Descriptions.Item label="类型">{data.style == 1 ? '图文' : '视频'}</Descriptions.Item>
                            <Descriptions.Item label="级别">{levelFil(data.level)}</Descriptions.Item>
                            <Descriptions.Item label="查看"><PreviewOpen theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" />&nbsp;{data.visit}</Descriptions.Item>
                            <Descriptions.Item label="时间" span={isXs?2:3}><Time theme="outline" size="16" fill="#999" strokeWidth={3} strokeLinejoin="miter" />&nbsp;{data.creat_date}</Descriptions.Item>
                        </Descriptions>
                    }</div>
                </PageHeader>
            </div >
            <div className="content">
                <Title level={4}>相关推荐</Title>
                <List
                    itemLayout="vertical"
                    size="large"
                    dataSource={list}
                    footer={null}
                    grid={{
                        gutter: 0, xs: 1, sm: 3, md: 3, lg: 3, xl: 4, xxl: 4,
                    }}
                    renderItem={item => (
                        <List.Item style={{ padding: '10px 10px', marginBottom: 0 }}>
                            <Link href={{
                                pathname: '/curriculum/[id]',
                                query: { id: item._id },
                            }} >
                                <a target="_blank" title={item.title}>
                                    <Card
                                        style={{ width: '100%', marginBottom: 0 }}
                                        cover={
                                            <img style={{
                                                height: "176px",
                                                objectFit: "cover"
                                            }} alt={item.title} src={cdnUrl + '/' + item.cover} />}
                                    >
                                        <Meta title={item.title} />
                                    </Card>
                                </a>
                            </Link>
                        </List.Item>
                    )}
                />
            </div>
        </Layout >
    )
}

FontId.getInitialProps = async ({ query, req }: NextPageContext) => {
    const res: any = await http(getCourseItem, { id: query.id }, req)
    return { data: res }
}

export default FontId